<template>
  <div class="box">
      <a-button 
          type="primary"
          class="code"
          @click="jumpTo"
        >跳转扫码登录页</a-button>
  </div>
</template>

<script>
// eslint-disable-next-line import/named
import { getCode } from './api';

export default {
  name: "TaskList",
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {
    async jumpTo() { 
      const res = await getCode();
      console.log(res);
      window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${res.appid}&redirect_uri=${res.redirect_uri}&response_type=code&scope=${res.scope}&state=${res.state}#wechat_redirect`
    }
  }
}
</script>

<style lang="less" scoped>
.code{
  margin: 32px;
}
</style>